
export enum ExceptionSummaryCd {
	LOAD = 'Load',
	POWER_MANAGEMENT = 'PowerManagement',
	SHIPMENT = 'Shipment'}

